import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function CommentsPage() {
  return (
    <SectionLayout title="Comments">
      {/* Comments content will go here */}
    </SectionLayout>
  );
} 